import { mergeStyles } from '@cian/utils';
import * as React from 'react';
import classnames from 'classnames';
import { useDeviceCondition } from '../../../../hooks';
import * as styles from './Row.css';
import { ICheckoutRowProps } from './types';

export const Row = (props: ICheckoutRowProps) => {
  const rootStyle = useDeviceCondition(styles['desktop'], styles['mobile']);

  const { isTotal, isDiscount, name, value, note } = props;

  return (
    <>
      <div {...mergeStyles(rootStyle, styles['row'], isTotal && styles['total'], isDiscount && styles['discount'])}>
        <div className={styles['name']}>{name}</div>
        <div data-name="TotalAmount" className={classnames(styles['value'], isDiscount && styles['discount'])}>
          {value}
        </div>
      </div>
      {!!note && (
        <div className={styles['row']}>
          <div className={styles['note']}>{note}</div>
        </div>
      )}
    </>
  );
};
